import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'meu-activate-account-page',
  templateUrl: './activate-account-page.component.html',
  styleUrls: ['./activate-account-page.component.scss']
})
export class ActivateAccountPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
